module.exports = __webpack_public_path__ + "img/logo.661642a8.png";